module.exports = "/src/views/eternal-dev/businesses/gas-station/images/light/LimitedLtd/header-background.svg";